module.exports = __webpack_public_path__ + "img/fruits.925d4198.png";